<script setup lang="ts">
import { useI18n } from "vue-i18n"

const { t } = useI18n({ useScope: "global" })
</script>

<template>
  <a id="opensourcelink-link-opensource" href="https://gitlab.com/plast8/razume" class="link" :title="t('footer.openSource')">{{ t("footer.openSourceShort") }}</a>
</template>
